module.exports = __webpack_public_path__ + "static/media/like.d527fe47.svg";